import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, router } from '@inertiajs/react';
import Notice from '../../../../molecules/Notice';
import { CopyrightCheckerDossierView } from './CopyrightCheckerDossier.view';
/**
 * @todo check everything by default
 * @todo show number of selected infringements in
 */
function InfringementDetails({ dossier }) {
    const { t } = useTranslation();
    const [notice, setNotice] = React.useState(null);
    const { data, setData, patch } = useForm({
        detections: [],
        status: 'approved',
    });
    const { patch: patchIgnore } = useForm({ ignored: !dossier.domain.ignored });
    const handleConfirmAll = () => {
        const confirmedCount = data.detections.length;
        const totalCount = dossier.photos.reduce((_, p) => {
            return _ + p.detections.length;
        }, 0);
        const newData = confirmedCount !== totalCount
            ? [
                ...dossier.photos.map(p => p.detections.map(({ id }) => id)),
            ].flat()
            : [];
        setData('detections', newData);
    };
    const handleConfirmGroup = (photo) => {
        const newData = new Set(data.detections);
        const groupConfirmed = photo.detections.every(detection => newData.has(detection.id));
        photo.detections.forEach(({ id }) => {
            if (groupConfirmed) {
                newData.delete(id);
            }
            else {
                newData.add(id);
            }
        });
        setData('detections', [...newData]);
    };
    const handleConfirm = (detection) => {
        const indexOfFound = data.detections.findIndex(id => detection.id === id);
        if (indexOfFound > -1) {
            const newVal = [...data.detections];
            newVal.splice(indexOfFound, 1);
            setData('detections', newVal);
            return;
        }
        setData('detections', [...data.detections, detection.id]);
    };
    const handleSubmit = () => {
        try {
            patch(window.location.href, {
                onSuccess() {
                    setNotice({
                        type: Notice.Type.SUCCESS,
                        text: t('Dossier Aangevraagd'),
                        title: t('Status'),
                    });
                },
            });
        }
        catch (e) {
            setNotice({
                type: Notice.Type.ERROR,
                text: t(''),
                title: 'Fout',
            });
        }
    };
    const handleIgnore = () => {
        const currentHref = window.location.href;
        const { domain: { id: domainId }, } = dossier;
        const confirmIgnore = confirm(t('Weet je zeker dat je deze bron wilt negeren?'));
        if (!confirmIgnore)
            return;
        try {
            patchIgnore(`/inbreuken/domeinen/${domainId}/mark-as-ignored`, {
                onSuccess() {
                    router.replace(currentHref);
                    setNotice({
                        type: Notice.Type.SUCCESS,
                        text: t('Bron genegeerd'),
                        title: t('Status'),
                    });
                },
            });
        }
        catch (e) {
            setNotice({
                type: Notice.Type.ERROR,
                text: t(''),
                title: 'Fout',
            });
        }
    };
    return (_jsx(CopyrightCheckerDossierView, { notice: notice, dossier: dossier, data: data, handleConfirmAll: handleConfirmAll, handleConfirmGroup: handleConfirmGroup, handleConfirm: handleConfirm, handleSubmit: handleSubmit, handleIgnore: handleIgnore }));
}
export default InfringementDetails;
